<template>
	<div class="control">
		<div class="form-group input-group">
			<datepicker :id="'form-' + parent.specification"
                :input-class="'date-control'"
				:placeholder="'Select Date'"
				:clear-button="true"
                @input="updateFilters"
                v-model="query"></datepicker>
		</div>
	</div>
</template>

<script>
	import Datepicker from 'vuejs-datepicker';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['control', 'parent'],
		data: function () {
			return {
				query: this.control.defaultValue,
			}
		},
		components: {
			'datepicker': Datepicker
        },
		mounted: function () {
			let initialData = this.$store.state.listing.specification[this.parent.specification];
			if (initialData !== '') {
				this.query = initialData;
			}
			// clear current input on reset
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/resetSpecification') {
					this.query = this.parent.defaultValue;
				}
			});

			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
                    const specificationVal = state.listing.specification[this.parent.specification];
                    this.query = specificationVal;
				}
			});
		},
		methods: {
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			updateFilters() {
				// if hitting api on each checkmark change
				if (this.query == null) {
					this.updateSpecification({ key: this.parent.specification, value: null });
				} else {
					const dateString = `${this.query.getFullYear()}-${this.query.getMonth() + 1}-${this.query.getDate()}`;
					this.updateSpecification({ key: this.parent.specification, value: dateString });
				}
                
			},
		}
	}
</script>